import axios from "axios";
import store from "@/store";
import router from "@/router";

export default function createHttp(secured = true) {

  let axiosInstance = null;
  if (secured) {
    axiosInstance = axios.create({
      headers: { "Authorization": `bearer ${store.state.token}` }
    });
  } else {
    axiosInstance =  axios.create({ headers: {"Access-Control-Allow-Origin": "*"} });
  }


  axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.status === 401) {
          debugger;
            // Handle the error, e.g., by redirecting to the login page
            // router.push('/login');
            store.dispatch("logout");
        }
        debugger;
        return Promise.reject(error);
    }
  );

  return axiosInstance;
} 